export enum VenueType {
    Algo = 'Algo',
    Conditional = 'Conditional',
    Alternative = 'Alternative',
    Dark = 'Dark',
    SI = 'SI',
    Exchange = 'Exchange',
    Lit = 'Lit MTF',
    OTC = 'OTC',
    Periodic = 'Periodic',
    Other = 'Other',
    SDP = 'SDP',
    Router = 'Router',
}

export const isLitOrExchange = (type: VenueType) =>
    type === VenueType.Exchange || type === VenueType.Lit;

export const isDark = (type: VenueType) => type === VenueType.Dark;

export const isSiOrSdp = (type: VenueType) =>
    type === VenueType.SI || type === VenueType.SDP;

export const isAlternativeOrPeriodic = (type: VenueType) =>
    type === VenueType.Alternative || type === VenueType.Periodic;

export const isConditional = (type: VenueType) =>
    type === VenueType.Conditional;

export const isNotConditional = (type: VenueType) => !isConditional(type);

export const isOther = (type: VenueType) =>
    !isLitOrExchange(type) &&
    !isDark(type) &&
    !isSiOrSdp(type) &&
    !isAlternativeOrPeriodic(type) &&
    !isConditional(type);

export const getVenueTypeClass = (type: string): string => {
    switch (type) {
        case VenueType.Exchange:
        case VenueType.Lit:
            return 'venue-yellow';
        case VenueType.Dark:
            return 'venue-navy';
        case VenueType.SI:
        case VenueType.SDP:
            return 'venue-light-green';
        case VenueType.Conditional:
        case VenueType.Alternative:
        case VenueType.Periodic:
            return 'venue-dark-green';
        default:
            return 'venue-grey';
    }
};

export const getVenueTypeText = (type: VenueType): string => {
    switch (type) {
        case VenueType.SDP:
            return 'Single Dealer Platform';
        case VenueType.OTC:
            return 'Over-The-Counter';
        case VenueType.SI:
            return 'Systematic Internaliser';
        default:
            return type;
    }
};

const venueTypeSortOrder = [
    VenueType.Exchange,
    VenueType.Lit,
    VenueType.Alternative,
    VenueType.Periodic,
    VenueType.SI,
    VenueType.SDP,
    VenueType.Dark,
    VenueType.Conditional,
    VenueType.OTC,
    VenueType.Algo,
    VenueType.Router,
    VenueType.Other,
];

export const getVenueTypeSortOrdinal = (venueType: VenueType): number => {
    const ordinal = venueTypeSortOrder.indexOf(venueType);
    return ordinal < 0 ? 99 : ordinal;
};
